import { axios, Response } from '../index'
import { UserInfo } from './get-post-by-id'

export type Comment = {
  id: number
  content: string
  author: UserInfo
  publishedAt: string
}

const getPostComments = (
  companyId: string,
  personaType: string,
  personaId: string,
  postId: number
): Response<Comment[]> => {
  return axios.get(`/v1/posts/${postId}/comments`, {
    headers: {
      'X-CompanyID': companyId,
      'X-PersonaType': personaType,
      'X-PersonaID': personaId
    }
  })
}

export default getPostComments
